'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = require('libphonenumber-js/core');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _core.getCountries;
  }
});
//# sourceMappingURL=getCountries.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-phone-number-input/modules/libphonenumber/getCountries.js
// module id = 8247
// module chunks = 0